import { createContext as e, useContext as t, useState as n } from "react";
import { Fragment as r, jsx as i } from "react/jsx-runtime";
// src/design/forms/datepicker/ui/ui-provider.tsx
var a = e(void 0), o = () => {
	let e = t(a);
	if (!e) throw Error("useUiContext must be used within ViewSwitcherProvider");
	return e;
}, s = ({ children: e, defaultView: t = "CALENDAR" }) => {
	let [r, o] = n(!1), [s, c] = n(t);
	return /* @__PURE__ */ i(a.Provider, {
		value: {
			currentView: s,
			setView: (e) => {
				c(e);
			},
			goToCalendarView: () => {
				c("CALENDAR");
			},
			goToMonthView: () => {
				c("MONTH");
			},
			goToYearView: () => {
				c("YEAR");
			},
			open: () => {
				o(!0);
			},
			close: () => {
				o(!1), c("CALENDAR");
			},
			toggle: () => {
				o((e) => !e);
			},
			isOpen: r
		},
		children: e
	});
}, c = {
	Provider: s,
	Consumer: ({ children: e }) => {
		let t = o();
		return /* @__PURE__ */ i(r, { children: e(t) });
	}
};
export { c as UiContext, s as UiContextProvider, o as useUiContext };

//# sourceMappingURL=ui-provider.js.map